// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"c18f2218","514":"cfcedc6a","554":"5f8bd72c","879":"b771ca98"}[chunkId] + ".chunk.js";
};